import React, { FC } from 'react'
import NextHead from 'next/head'
import { useRouter } from 'next/router'
import { useStoreConfig } from '@config/hooks/useStoreConfig'

const Head: FC = () => {
    const { locale = 'en', asPath } = useRouter()
    const config = useStoreConfig()
    let baseUrl = config?.base?.url?.baseUrl + asPath.slice(1)
    if (baseUrl.endsWith('/')) {
        baseUrl = baseUrl.slice(0, -1)
    }
    const getHrefLang = () => (locale === 'ar' ? 'ar-ae' : 'en-ae')

    const getUrlOpposite = () =>
        locale === 'en'
            ? baseUrl.replace('/en', '/ar')
            : baseUrl.replace('/ar', '/en')

    const oppositeLang = () => (locale === 'ar' ? 'en-ae' : 'ar-ae')

    return (
        <NextHead>
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1"
            />
            <link
                rel="manifest"
                href="/stores/ooka_uae_store/site.webmanifest"
                key="site-manifest"
                crossOrigin="use-credentials"
            />
            <link rel="alternate" href={baseUrl} hrefLang={getHrefLang()} />
            <link
                rel="alternate"
                href={getUrlOpposite()}
                hrefLang={oppositeLang()}
            />
        </NextHead>
    )
}

export default Head
